import find from 'lodash/find';
import { Container, Box, Flex } from '@qga/roo-ui/components';

import { useScrollTopOnMount, useTitleOnMount, useDetailsBooking } from 'lib/hooks';

import { GlobalDisclaimers, CreditVoucherDisclaimer } from 'components/Disclaimers';
import PageSubHeader from 'components/PageSubHeader';
import PageHeader from './PageHeader';
import MobileOnlyPropertyImage from './MobileOnlyPropertyImage';
import BookingNotifications from './BookingNotifications';
import BookingDetails from './BookingDetails';
import GuestInformation from './GuestInformation';
import QantasPointsEarn from './QantasPointsEarn';
import { KnowBeforeYouGoWithTracking } from './KnowBeforeYouGo';
import ChargeSummary from './ChargeSummary';
import PaymentSummary from './PaymentSummary';
import CancellationSummary from './CancellationSummary';
import CancellationPolicy from './CancellationPolicy';
import DesktopManageBookingActions from './ManageBookingActions/DesktopManageBookingActions';
import MobileTabletManageBookingActions from './ManageBookingActions/MobileTabletManageBookingActions';
import NeedHelp from './NeedHelp';

const BookingDetailsPage = () => {
  const { booking } = useDetailsBooking();

  useScrollTopOnMount();
  useTitleOnMount(`Hotel Reservation ${booking.reference}`);

  const {
    flags: { isCancelled },
  } = booking;

  const displayCreditVoucherDisclaimer = find(booking.cancellationRefund?.breakdown, { method: 'credit_note' });

  return (
    <>
      <PageHeader />
      <MobileOnlyPropertyImage booking={booking} />

      <Container>
        <PageSubHeader title={booking.summaryText} />
        <BookingNotifications booking={booking} />
      </Container>

      <Container>
        <Flex>
          <Box width="100%">
            <BookingDetails booking={booking} />
            <MobileTabletManageBookingActions />
            <KnowBeforeYouGoWithTracking booking={booking} />
            <GuestInformation booking={booking} />
            <QantasPointsEarn booking={booking} />
            <CancellationPolicy booking={booking} />
            <ChargeSummary booking={booking} />
            {isCancelled && <CancellationSummary booking={booking} />}
            <PaymentSummary booking={booking} />
            <NeedHelp />
          </Box>
          <DesktopManageBookingActions />
        </Flex>
      </Container>

      <Container mt={12}>
        {displayCreditVoucherDisclaimer && <CreditVoucherDisclaimer.Body />}
        <GlobalDisclaimers />
      </Container>
    </>
  );
};

export default BookingDetailsPage;
